import { gql } from "@apollo/client";
export const ADMIN_WINERY_MEMBER_GROUP_GET_ALL = gql `
  query AdminWineryGetAll {
    AdminWineryGetAll {
      _id
      name
    }
  }
`;
